// extracted by mini-css-extract-plugin
module.exports = {"root":"HotTip_root__fRUoq","title":"HotTip_title__Lfb3a","content":"HotTip_content__GwKOM"};